import type { TransferAstRelayResponse } from 'features/call/call-base/interfaces';
import { CallDaoService } from 'features/call/call-base/services';

export const transferCallOwnershipToAST = async (callId: number) => {
  const transferAstRelayResponse =
    await CallDaoService.transferASTRelay(callId);
  return transferAstRelayResponse;
};

export const transferCallToAST = async (
  _transferAstRelayResponse: TransferAstRelayResponse
) => {
  /*
   * TODO(AST-SIGNMAIL-ADM-TRANSFER):
   * Call ADM to transfer the call using callId and voiceSessionId from
   * the relay response Call payload, along with any other relay response data.
   */
};
